import Listing from "./listing";
import React, { Component } from "react";
import request from "superagent";
import { getAgentIds } from "../shared/util";

import "./index.scss";

export default class GlobalListingDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listing: null,
    };
  }

  componentDidMount() {
    this.getGlobalListing(this.props.params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.getGlobalListing(nextProps.props.params.id);
    }
  }

  // gets global listing detail page data
  getGlobalListing = (id) => {
    request
      .get(`/api/globalListings/findListing/?id=${id}`)
      .set("Content-Type", "application/json")
      .send()
      .end((error, response) => {
        if (response && response.body) {
          if (response.body.result) {
            this.setState({
              listing: response.body.result,
            });
            this.props.actions.loadListingDetail(response.body.result);
          } else {
            this.props.router.goBack();
          }
        } else {
          console.error(error);
        }
      });
  };

  render() {
    let listing = this.state.listing ? (
      <Listing
        config={this.props.config}
        listing={this.state.listing}
        entity={this.props.entity}
      />
    ) : null;
    return (
      <div className="listingDetailPage" style={{ minHeight: "100vh" }}>
        {listing}
        <div className="print-font-loader">
          <f1 />
          <f2 />
          <f3 />
          <f4 />
          <f5 />
        </div>{" "}
        {/* loads custom fonts for print view */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/listing-detail/globalListingDetails.js